<template>
  <label class="ToggleButton" :class="{ checked: modelValue }">
    <span v-if="!!label" class="CheckboxLabel">{{ label }}</span>
    <slot v-else></slot>
    <span class="CheckboxInner">
        <input
        type="checkbox"
        class="CheckboxInput"
        :name="name"
        :id="id"
        :checked="modelValue"
        :disabled="disabled"
        @change="handleChange"
      />
      </span>
  </label>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  props: {
    id: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    hover: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const isChecked = ref<boolean>(props.modelValue)

    const handleChange = ({ target }: Event) => {
      isChecked.value = (target as HTMLInputElement).checked
      emit('update:modelValue', isChecked.value)
    }

    return {
      isChecked,
      handleChange,
    }
  }
})
</script>

<style scoped>
.ToggleButton {
  box-sizing: border-box;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid var(--semantic-colors-border-box);
  background: var(--semantic-colors-background-white);
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ToggleButton.checked {
  border: 2px solid var(--primitive-colors-basic-yellow-600);
  background: var(--primitive-colors-basic-yellow-100);
}

.CheckboxInput {
  display: none;
}

.CheckboxLabel {
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.15px;
  min-height: 18px;
  word-break: keep-all;
}

.ToggleButton.checked .CheckboxLabel {
  font-weight: 700;
  color: var(--primitive-colors-basic-yellow-600);
}

:slotted(.ToggleButton.checked > *) {
  font-weight: 700;
  color: var(--primitive-colors-basic-yellow-600);
}
</style>